import { inject } from '@angular/core';
import { forkJoin } from 'rxjs';
import { NavigationService } from './core/navigation/navigation.service';
import { ShortcutsService } from './layout/common/shortcuts/shortcuts.service';
import { UserService } from './core/user/user.service';

export const initialDataResolver = () =>
{
    
    //const messagesService = inject(MessagesService);
    const navigationService = inject(NavigationService);
    const userService = inject(UserService);
    const shortcutsService = inject(ShortcutsService);

    // Fork join multiple API endpoint calls to wait all of them to finish
    return forkJoin([
        navigationService.get(),
        userService.current(),
        //notificationsService.getAll(),
        shortcutsService.getAll(),
        
    ]);
};